import { Injectable } from '@angular/core';
import { PortalLog, SearchLog } from '../_models/admin';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortalLogService {

  constructor(private http: HttpClient) { }

  getPortalLogs(searchLogDto:any): Observable<PortalLog[]> {
      return this.http.post<PortalLog[]>(environment.apiUrl + `/portal/logs`,searchLogDto);
    }

  addLogOutActivity(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + `/portal/logout`);
  }
}
